import React, {useState, useEffect, useRef} from 'react';
import MotifLabel from '@ey/motif-react-wrapper/Label';
import MotifSearch from '@ey/motif-react-wrapper/Search';
import MotifSelect from '@ey/motif-react-wrapper/Select';
import MotifOption from '@ey/motif-react-wrapper/Option';
import MotifErrorMessage from '@ey/motif-react-wrapper/ErrorMessage';
import MotifFormField from '@ey/motif-react-wrapper/FormField';
import MotifButton from '@ey/motif-react-wrapper/Button';
import {
	labels,
	dateFormatsListItems,
	dateFormats,
	messageTypeList
} from '../../../util/uiconstants';
import CheckBox from '../../Common/Checkbox/CheckBox';
import DateTimePicker from '../../Common/MotifDateTimePicker/datetimepicker';
import styled from 'styled-components';
import {useSelector, useDispatch} from 'react-redux';
import env from '../../../util/env';
import * as masterdataactions from '../../../actions/admin/masterDataActions';
import RichTextEditorWrapper from '../../Common/KendoEditor/RichTextEditorWrapper';
import Loader from '../../Common/Loaders/loadingindicator';
import Toast from '../../Common/Toast/Toast';
import {getMessageById} from '../../../actions/admin/messagingactions';
import TicketField from '../common/ticketfield';
import {compareArray, validateTicketNumber} from '../common/util';
import EllipsesControl from '../../Common/EllipsesControl/EllipsesControl';

const Wrapper = styled.section`
	//ticketstart
	.ticketdetail {
		padding: var(--spacing-x-large) 0;
		border-top: var(--px-1) solid var(--neutrals-300);
		.description {
			padding-bottom: var(--spacing-small);
		}

		.motif-form-field {
			width: var(--px-400);
			.motif-input {
				height: var(--px-44);
			}
		}
	}
	//ticketend

	.loadingstyle {
		position: absolute;
		top: 50%;
		left: 50%;
	}

	.createmessagewrapper {
		display: flex;
		width: 100%;
		font-size: var(--px-14);
		height: calc(100vh - var(--px-194));
		padding: var(--spacing-x-large);
		padding-bottom: 0;

		& * .motif-error-message {
			margin-top: var(--px-5);
		}

		& * svg {
			width: var(--px-15) !important;
			height: var(--px-15) !important;
		}

		.kendoeditor {
			.k-widget {
				resize: none;
			}

			.kendo-editor-label label {
				font-weight: normal;
			}
		}

		.toastMessage {
			.motif-toast-text-container {
			}

			&.block {
				display: block;
			}

			&.none {
				display: none;
			}
		}

		.holder {
			width: 100%;
			display: inline-block;
		}

		.motif-search-input-wrapper {
			display: inline-block;
			width: 100%;
			position: relative;
		}

		.motif-input,
		.motif-select-trigger {
			height: var(--px-44);
		}

		h4 {
			font-size: var(--px-14);
			font-weight: bold;
		}

		.kendoeditor {
			padding: var(--spacing-x-large) 0;
		}

		.currentutc {
			display: flex;
			padding: var(--spacing-x-large) 0;
			.currentutclabel {
				/* font-weight: bold; */
			}
		}

		.startendtime {
			display: flex;

			.starttime,
			.endtime {
				flex-grow: 1;
				.select {
					padding: var(--spacing-large) 0;
				}
				.datepicker {
					display: flex;
					align-items: center;
					.dateField {
						display: inline-flex;
						width: 64%;
						padding-right: var(--px-16);
						.react-date-picker__calendar {
							z-index: 1000 !important;
						}
					}
					.timeField {
						display: inline-flex;
						width: 36%;
					}
				}
			}
		}

		.datacenterwrapper {
			display: flex;
			padding-bottom: var(--spacing-x-large);

			& > * {
				width: 50%;
			}
		}

		.alldatacenter {
			flex-grow: 1;
			.datacenter-title {
				padding-bottom: var(--spacing-large);
			}
			.motif-checkbox-label {
				display: flex;
				width: 100%;
			}
		}

		.datacenter {
			flex-grow: 1;
			.datacenter-title {
				padding-bottom: var(--spacing-large);
			}
		}

		.display-msgtype {
			width: 45.2%;
			margin-bottom: var(--spacing-x-large);
			@media screen and (min-width: 992px) and (max-width: 1366px) {
				width: 48.2%;
			}
			.displaymsgtype-title {
				padding-bottom: var(--spacing-large);
			}
			.motif-select-wrapper-options {
				width: 100% !important;
			}
		}
	}
	.modal-footer {
		display: inline-flex;
		width: 100%;
		justify-content: end;
		padding: var(--spacing-x-large);
		button {
			margin-left: var(--px-12);
		}
		.motif-error-message {
			margin: 0;
		}
	}
`;

function CreateEditMessage(props) {
	const dispatch = useDispatch();
	const screenRef = useRef(null);
	const dataCenters = useSelector((store) => store.dataCenters);
	const messageDetails = useSelector((store) => store.messageDetails);

	const [startDateTimeString, setStartDateTimeString] = useState('');
	const [endDateTimeString, setEndDateTimeString] = useState('');
	const [messageTitle, setMessageTitle] = useState('');
	const [messageDescription, setMessageDescription] = useState('');
	const [allDataCentersChecked, setAllDataCentersChecked] = useState(true);
	const [selectedDataCenters, setSelectedDataCenters] = useState([]);
	const [showMessageTitleValidation, setShowMessageTitleValidation] =
		useState(false);
	const [showMessageTypeValidation, setShowMessageTypeValidation] =
		useState(false);
	const [
		showMessageDescriptionValidation,
		setShowMessageDescriptionValidation
	] = useState(false);
	const [showEndDateTimeValidation1, setShowEndDateTimeValidation1] =
		useState(false);
	const [showEndDateTimeValidation2, setShowEndDateTimeValidation2] =
		useState(false);
	const [showDataCenterValidation, setShowDataCenterValidation] =
		useState(false);
	const [clearDropdownSelection, setClearDropdownSelection] = useState(0);
	const [messageDescriptionPlainText, setMessageDescriptionPlainText] =
		useState('');
	const [startDateRequired, setStartDateRequired] = useState(false);
	const [endDateRequired, setEndDateRequired] = useState(false);
	const [isLoading, setIsLoading] = useState(
		props.isEditMessage ? true : false
	);
	const [ticketNumber, setTicketNumber] = useState('');
	const [isSubmitClicked, setIsSubmitClicked] = useState(false);
	const [validationMessage, setValidationMessage] = useState('');
	const [messageTypeID, setMessageTypeID] = useState(1);

	useEffect(() => {
		if (screenRef.current && screenRef.current.scrollTop) {
			screenRef.current.scrollTop = 0;
		}
	}, [screenRef, isLoading]);

	useEffect(() => {
		getAllDataCenters();

		if (props.isEditMessage) {
			getMessageDetails();
		}
	}, []);

	useEffect(() => {
		if (props.isEditMessage && Object.keys(messageDetails).length > 0) {
			const dataCenters = extractDataCenterIds(messageDetails.dataCenterList);

			setStartDateTimeString(messageDetails.releaseOnDate + '.000Z');
			setEndDateTimeString(messageDetails.expireOnDate + '.000Z');
			setMessageTitle(messageDetails.messageTitle);
			setMessageDescription(messageDetails.messageText);
			setAllDataCentersChecked(messageDetails.isSystemWide);
			setSelectedDataCenters(dataCenters);
			setMessageTypeID(messageDetails.messageTypeID || 1);
			//render modal contents once the message details are loaded
			setIsLoading(false);
		}
	}, [messageDetails]);

	// To keep track of the changes in input fields and show validation messages
	useEffect(() => {
		if (isSubmitClicked) {
			validateDataonSave();
		}
	});

	const extractDataCenterIds = (dataCenterList) => {
		return dataCenterList.map((x) => x.dataCenterId.toString());
	};

	const getMessageDetails = () => {
		setIsLoading(true);
		let messageByIdUrl =
			env.getURL('serviceUrlV2') + `admin/Messages/${props.messageId}`;

		dispatch(getMessageById(messageByIdUrl)).catch(() => {
			setIsLoading(false);
		});
	};

	const getAllDataCenters = () => {
		let dataCenterUrl = env.getURL('serviceUrlV2') + 'datacenters';
		if (Object.keys(dataCenters).length === 0) {
			dispatch(masterdataactions.getCountryDataCenters(dataCenterUrl)).then(
				() => {}
			);
		}
	};

	const getDataCentersForDropDown = () => {
		let dataCenterList = [];
		if (Object.keys(dataCenters).length > 0) {
			_.forEach(dataCenters, (item) => {
				if (item) {
					dataCenterList.push({
						value: item.dataCenterID.toString(),
						label: item.dataCenterName
					});
				}
			});
		}
		return dataCenterList;
	};

	const validateDataonSave = () => {
		setValidationMessage('');
		let isValid = true;
		if (!validateMessageTitle(messageTitle)) {
			isValid = false;
		}

		if (!validateMessageDescription(messageDescription)) {
			isValid = false;
		}

		if (!validateMessageType(messageTypeID)) {
			isValid = false;
		}

		if (!validateStartDateTime(startDateTimeString)) {
			isValid = false;
		}

		if (!validateEndDateTime(endDateTimeString)) {
			isValid = false;
		}

		if (!validateDataCenters(allDataCentersChecked, selectedDataCenters)) {
			isValid = false;
		}

		if (!validateTicketNumber(ticketNumber)) {
			isValid = false;
		}

		if (!isValid) {
			setValidationMessage(labels.messageSubmitValidationError);
		} else if (validateSameData()) {
			setValidationMessage(labels.messageChangesValidationError);
			isValid = false;
		}

		return isValid;
	};

	const validateSameData = () => {
		if (messageTitle !== messageDetails.messageTitle) {
			return false;
		}
		if (messageDescription !== messageDetails.messageText) {
			return false;
		}
		if (messageTypeID !== messageDetails.messageTypeID) {
			return false;
		}
		if (startDateTimeString !== messageDetails.releaseOnDate + '.000Z') {
			return false;
		}
		if (endDateTimeString !== messageDetails.expireOnDate + '.000Z') {
			return false;
		}
		if (allDataCentersChecked != messageDetails.isSystemWide) {
			return false;
		}
		if (selectedDataCenters.length > 0) {
			let originalData =
				messageDetails.dataCenterList?.map((dataCenter) =>
					dataCenter?.dataCenterId?.toString()
				) ?? [];
			let isSimilarDataCenters = compareArray(
				originalData,
				selectedDataCenters
			);
			if (!isSimilarDataCenters) {
				return false;
			}
		}
		return true;
	};

	const validateMessageType = (messageTypeID) => {
		setShowMessageTypeValidation(false);
		if (!messageTypeID || messageTypeID <= 0) {
			setShowMessageTypeValidation(true);
			return false;
		}
		return true;
	};

	const validateMessageTitle = (messageTitle) => {
		setShowMessageTitleValidation(false);
		if (
			!messageTitle ||
			messageTitle.length > 500 ||
			_.trim(messageTitle).length <= 0
		) {
			setShowMessageTitleValidation(true);
			return false;
		}
		return true;
	};

	const validateMessageDescription = (descriptionText) => {
		setShowMessageDescriptionValidation(false);
		if (
			!messageDescriptionPlainText ||
			messageDescriptionPlainText.length <= 0
		) {
			setShowMessageDescriptionValidation(true);
			return false;
		}
		if (descriptionText?.length > 4000) {
			return false;
		}
		return true;
	};

	const validateStartDateTime = (startDateTimeString) => {
		setStartDateRequired(false);
		if (startDateTimeString == '') {
			setStartDateRequired(true);
			return false;
		}
		return true;
	};

	const validateEndDateTime = (endDateTimeString) => {
		setShowEndDateTimeValidation1(false);
		setShowEndDateTimeValidation2(false);
		setEndDateRequired(false);
		if (endDateTimeString === '') {
			setEndDateRequired(true);
			return false;
		}
		var startDateTime = new Date(startDateTimeString);
		var endDateTime = new Date(endDateTimeString);

		if (endDateTime <= startDateTime) {
			setShowEndDateTimeValidation2(true);
			return false;
		}
		var currentDateTime = new Date();
		if (endDateTime < currentDateTime) {
			setShowEndDateTimeValidation1(true);
			return false;
		}
		return true;
	};

	const validateDataCenters = (allDataCenters, selectedDataCenters) => {
		setShowDataCenterValidation(false);
		if (allDataCenters) {
			return true;
		}
		if (selectedDataCenters.length === 0) {
			setShowDataCenterValidation(true);
			return false;
		}
		return true;
	};

	const onMessageSave = () => {
		setIsSubmitClicked(true);
		if (validateDataonSave()) {
			let saveMessageModel = {
				title: messageTitle,
				description: messageDescription,
				startsOn: startDateTimeString,
				endsOn: endDateTimeString,
				isSystemWide: allDataCentersChecked,
				dataCenters: selectedDataCenters,
				ticketNumber: ticketNumber,
				messageTypeID: messageTypeID
			};
			setStartDateTimeString('');
			setEndDateTimeString('');
			setIsSubmitClicked(false);
			if (props.isEditMessage) {
				props.onEditMessageAPICall(saveMessageModel);
			} else {
				props.onSaveMessageClick(saveMessageModel);
			}
		}
	};

	const onMessageTitleChange = (e) => {
		setShowMessageTitleValidation(false);
		setMessageTitle(e.target.value);
	};

	const onMessageDescriptionChange = (e) => {
		setShowMessageDescriptionValidation(false);
		const text = typeof e === 'string' ? e : e.value;
		setMessageDescription(text);
	};

	const onStartDateTimeChange = (dateTime) => {
		setStartDateRequired(false);
		setStartDateTimeString(dateTime);
	};

	const onEndDateTimeChange = (dateTime) => {
		setEndDateRequired(false);
		setShowEndDateTimeValidation1(false);
		setShowEndDateTimeValidation2(false);
		setEndDateTimeString(dateTime);
	};

	const onCheckBoxChange = () => {
		setShowDataCenterValidation(false);
		setAllDataCentersChecked(!allDataCentersChecked);
		setClearDropdownSelection(clearDropdownSelection + 1);
		setSelectedDataCenters([]);
	};

	const dropDownOnChange = (option) => {
		setShowDataCenterValidation(false);
		setSelectedDataCenters(option);
	};

	const padTo2Digits = (num) => {
		return num.toString().padStart(2, '0');
	};

	const currentUTCDateTime = () => {
		const date = new Date();
		const yyyy = date.getUTCFullYear();
		const mm = padTo2Digits(date.getUTCMonth() + 1);
		const dd = padTo2Digits(date.getUTCDate());
		const hh = padTo2Digits(date.getUTCHours());
		const mn = padTo2Digits(date.getUTCMinutes());

		var currentUTCDateTime = `${mm}-${dd}-${yyyy} ${hh}:${mn}`;
		return currentUTCDateTime;
	};

	const handlerOnTicketEntered = (e) => {
		setTicketNumber(e.target.value);
	};

	const handleMessageTypeChange = (value) => {
		setMessageTypeID(parseInt(value));
	};

	return (
		<Wrapper>
			{isLoading || props?.createEditMessageLoading ? (
				<Loader variant={'circular'} />
			) : (
				<>
					<section
						ref={screenRef}
						className="createmessagewrapper customScrollbar"
					>
						<section className="holder">
							<section
								className="toastMessage"
								style={{
									display:
										props?.createEditErrorMessage.length > 0 ? 'block' : 'none'
								}}
							>
								<Toast
									variant="error"
									onClose={() => props.setCreateEditErrorMessage('')}
								>
									{props?.createEditErrorMessage}
								</Toast>
							</section>

							{/* Message Title */}
							<section>
								<MotifSearch
									maxLength={500}
									value={messageTitle}
									onChange={onMessageTitleChange}
									placeholder={labels.messageName}
									title={messageTitle}
									clearHoverText={labels.clear}
									onClear={() => setMessageTitle('')}
								></MotifSearch>
								{showMessageTitleValidation ? (
									<MotifErrorMessage>
										{labels.messageFieldRequired}
									</MotifErrorMessage>
								) : (
									''
								)}
							</section>

							{/* Message Description */}
							<section className="kendoeditor">
								<RichTextEditorWrapper
									charactersLabel={labels.characters}
									label={labels.messageKendoDescription}
									ofLabel={labels.ofLabel}
									value={messageDescription}
									placeholder={labels.messagingDescriptionTitle}
									numberFormat={0}
									onChange={onMessageDescriptionChange}
									maxCharCount={4000}
									showMaxCharacterCount
									useMinimalToolset={false}
									resizable
									getPlainText={(value) => {
										setMessageDescriptionPlainText(value);
									}}
								/>
								{showMessageDescriptionValidation ? (
									<MotifErrorMessage>
										{labels.messageFieldRequired}
									</MotifErrorMessage>
								) : (
									''
								)}
							</section>

							{/* Start and end time and date */}
							<section className="startendtime">
								<section className="starttime">
									<section className="motif-body1-default-regular">
										{labels.messageStartsOn}
									</section>
									<section className="select motif-body1-default-light">
										{labels.messageDateTime}
									</section>
									<DateTimePicker
										label={labels.messageSelectADate}
										dateFormat={dateFormatsListItems[dateFormats].format}
										value={startDateTimeString}
										onChange={onStartDateTimeChange}
										todayMark={true}
									/>
									<section className="moreinfo motif-label4-default-light">
										{labels.messageAllTimeInUTC}
									</section>
									{startDateRequired ? (
										<MotifErrorMessage>
											{labels.messageFieldRequired}
										</MotifErrorMessage>
									) : (
										''
									)}
								</section>

								<section className="endtime">
									<section className="motif-body1-default-regular">
										{labels.messageEndsOn}
									</section>
									<section className="select motif-body1-default-light">
										{labels.messageDateTime}
									</section>
									<section>
										<DateTimePicker
											label={labels.messageSelectADate}
											dateFormat={dateFormatsListItems[dateFormats].format}
											value={endDateTimeString}
											onChange={onEndDateTimeChange}
											todayMark={true}
										/>
									</section>
									<section className="moreinfo motif-label4-default-light">
										{labels.messageAllTimeInUTC}
									</section>
									{endDateRequired ? (
										<MotifErrorMessage>
											{labels.messageFieldRequired}
										</MotifErrorMessage>
									) : (
										''
									)}
									{showEndDateTimeValidation1 ? (
										<MotifErrorMessage>
											{labels.messageEndTimeError1}
										</MotifErrorMessage>
									) : (
										''
									)}
									{showEndDateTimeValidation2 ? (
										<MotifErrorMessage>
											{labels.messageEndTimeError2}
										</MotifErrorMessage>
									) : (
										''
									)}
								</section>
							</section>

							<section className="currentutc">
								<section className="currentutclabel motif-body1-default-regular">
									{labels.currentutc}
								</section>
								<section className="motif-body1-default-light">
									{labels.messageCurrentUTCTime.replace(
										'{0}',
										currentUTCDateTime
									)}
								</section>
							</section>

							<section className="datacenterwrapper">
								{/* Target Audience */}
								<section className="alldatacenter">
									<section className="datacenter-title motif-body1-default-regular">
										{labels.messageTargetAudience}
									</section>
									<section>
										<CheckBox
											styleName="checkoption-item"
											label={labels.messageAllDataCenters}
											id={'alldatacenters'}
											value={'allDataCenters'}
											name="alldatacentres"
											onChange={onCheckBoxChange}
											checked={allDataCentersChecked}
											hidetitletip
										/>
									</section>
								</section>

								{/* Data center list */}
								<section className="datacenter">
									<section className="datacenter-title motif-body1-default-regular">
										{labels.messageDataCenters}
									</section>
									<section>
										<MotifFormField>
											<MotifLabel id="select-label-search" position="in">
												{labels.messageSelectDataCenter}
											</MotifLabel>
											<MotifSelect
												id={'Datacenters'}
												onChange={(e) => dropDownOnChange(e)}
												filter
												value={
													selectedDataCenters?.length
														? selectedDataCenters
														: null
												}
												arialabelledby="select-label-search"
												multiple={true}
												showselectallbutton
												key={clearDropdownSelection}
												className="datacenter"
												disabled={allDataCentersChecked}
											>
												{getDataCentersForDropDown()?.map((item) => (
													<MotifOption
														key={item.value}
														value={item.value}
														label={item.label}
													>
														<EllipsesControl
															content={item.label}
															tooltip={item.label}
															noOfLines={1}
														/>
													</MotifOption>
												))}
											</MotifSelect>
											{showDataCenterValidation ? (
												<MotifErrorMessage>
													{labels.messageDataCenterError}
												</MotifErrorMessage>
											) : (
												''
											)}
										</MotifFormField>
									</section>
								</section>
							</section>
							<section className="display-msgtype">
								<section className="displaymsgtype-title motif-body1-default-regular">
									{labels.displaymessagein}
								</section>
								<MotifFormField>
									<MotifLabel id="message-type-label" position="in">
										{labels.selectmessagetype}
									</MotifLabel>
									<MotifSelect
										value={`${messageTypeID}`}
										multiple={false}
										className="displaymsgtype-select"
										onChange={(e) => handleMessageTypeChange(e)}
										arialabelledby="message-type-label"
									>
										{messageTypeList.map((item) => (
											<MotifOption
												key={item.id}
												value={`${item.id}`}
												label={item.value}
											>
												<EllipsesControl
													content={item.value}
													tooltip={item.value}
													noOfLines={1}
												/>
											</MotifOption>
										))}
									</MotifSelect>
									{showMessageTypeValidation ? (
										<MotifErrorMessage>
											{labels.messageFieldRequired}
										</MotifErrorMessage>
									) : (
										''
									)}
								</MotifFormField>
							</section>
							<section>
								<TicketField
									ticketNumber={ticketNumber}
									onTicketChanged={handlerOnTicketEntered}
									showValidation={isSubmitClicked}
								/>
							</section>
						</section>
					</section>
					<section className="modal-footer">
						{validationMessage.length > 0 && (
							<MotifErrorMessage>{validationMessage}</MotifErrorMessage>
						)}
						<MotifButton
							variant="ghost"
							size="medium"
							onClick={() => {
								props.onCreateEditMessageModalClose(false);
							}}
							disabled={props.buttonDisable}
						>
							{labels.cancel}
						</MotifButton>
						<MotifButton
							variant="primary"
							size="medium"
							onClick={onMessageSave}
							disabled={props.buttonDisable}
						>
							{labels.save}
						</MotifButton>
					</section>
				</>
			)}
		</Wrapper>
	);
}

export default CreateEditMessage;
